// extracted by mini-css-extract-plugin
export default {"wrapTable":"table_wrapTable__sr8P2","table":"table_table__YaWi-","item":"table_item__xxlI6"};